import { Component, inject } from '@angular/core'
import { SalaryComponent } from '../../../store/salary-components/salary-components.state'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { CommonModule, NgFor, NgIf } from '@angular/common'
import { HasPermissionDirective } from '../../../directives/has-permission.directive'
import { Store } from '@ngrx/store'
import { selectSalaryComponents } from '../../../store/salary-components/salary-components.selectors'
import { STATUTORY_DEDUCTIONS } from '../../../store/state.constants'
import {
  addSalaryComponent,
  deleteSalaryComponent,
  editSalaryComponent,
  loadSalaryComponents
} from '../../../store/salary-components/salary-components.actions'

@Component({
  selector: 'app-statutory-deductions',
  imports: [NgFor, NgIf, FormsModule, ReactiveFormsModule, CommonModule, HasPermissionDirective],
  templateUrl: './statutory-deductions.component.html',
  styleUrl: './statutory-deductions.component.scss'
})
export class StatutoryDeductionsComponent {
  private modalService = inject(NgbModal)
  private fb = inject(FormBuilder)
  private store = inject(Store)

  //States
  form!: FormGroup
  operation = 'Add'
  itemId = ''

  //Add modal for the items
  //@ViewChild("addEarningModal", { static: true })
  //earningModalTemplate: TemplateRef<unknown>;

  //@ViewChild("deleteModal", { static: true })
  //deleteModalTemplate: TemplateRef<unknown>;

  statutoryDeductions$ = this.store.select(selectSalaryComponents(STATUTORY_DEDUCTIONS))

  constructor() {
    this.initializeForm()
    this.store.dispatch(
      loadSalaryComponents({ componentType: STATUTORY_DEDUCTIONS, belongsTo: null })
    )
  }

  initializeForm() {
    this.form = this.fb.group({
      belongsTo: [''],
      name: ['', Validators.required],
      description: [''],
      componentType: [STATUTORY_DEDUCTIONS],
      info: this.fb.group({
        payType: ['fixedPay'],
        calculationType: ['flatAmount'],
        paymentFrequency: ['monthly'],
        taxDeductionPreference: ['subsequentPayrolls'],
        taxable: [true],
        isInCTC: [true],
        isInFBP: [true],
        proRataBasis: [true],
        EPFContribution: [true],
        ESIContribution: [true],
        optional: [true]
      })
    })
  }

  sendDataToParent() {
    switch (this.operation) {
      case 'Add':
        this.store.dispatch(addSalaryComponent({ salaryComponent: this.form.value }))
        break
      case 'Edit':
        this.store.dispatch(
          editSalaryComponent({ id: this.itemId, salaryComponent: this.form.value })
        )
        break
      case 'Delete':
        this.store.dispatch(
          deleteSalaryComponent({ id: this.itemId, componentType: STATUTORY_DEDUCTIONS })
        )
        break
      default:
        break
    }
    this.onClose()
  }

  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }
    return null // No error
  }

  openModel(modal: unknown) {
    this.operation = 'Add'
    this.itemId = ''
    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }
  openEditModal(modal: unknown, itemData: SalaryComponent) {
    this.operation = 'Edit'
    this.itemId = itemData.id
    this.form.get('belongsTo')?.setValue(itemData.belongsTo)
    this.form.get('name')?.setValue(itemData.name)
    this.form.get('description')?.setValue(itemData.description)
    this.form.get('type')?.setValue(itemData.componentType)
    this.form.get('info')?.setValue(itemData.info)
    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }
  openDeleteModal(modal: unknown, itemData: SalaryComponent) {
    this.operation = 'Delete'
    this.itemId = itemData.id
    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
  }

  onClose() {
    this.modalService.dismissAll()
    this.form.reset()
    this.initializeForm()
  }
}
